module.exports = __webpack_public_path__ + "img/scc-04.08352d59.png";